export default {
  downtimeUrl: "https://tr6.kodland.tech",
  startPage: {
    image: "/welcome/quiz_project_girl.jpeg",
    title: "5 soruyu yanıtlayın ve çocuğunuz için ÜCRETSİZ ders alın",
    subtitle:
      "Çocuklar dijital yaratıcılıklarını keşfedecek: Çizgi film, animasyon, illüstrasyon, modelleme, 3D tasarım",
    button: "Ders alın 🚀",
  },
  successPage: {
    title: "Ücretsiz dersinizi almak için tarih belirleyin 🚀",
    subtitle: "📆 Hemen Kaydol butonuna tıklayarak rezervasyonu tamamlayabilirsiniz.",
    button: "📆 Hemen Kaydol",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
      answers: [
        "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
        "🎮 Cep telefonunda veya bilgisayarda oyun oyna",
        "🕹 Masa oyunları oyna",
        "⚽️ Spor yapa",
        "👨‍👩‍👦 Ailesiyle vakit geçiri",
        "👀 Çizgi film izliyo",
        "🤝 Arkadaşlarla konuşu",
      ],
    },
    2: {
      question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
      answers: [
        "🔬 Fen bilimleri",
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "🗣 Yabancı diller",
        "➗ Matematik",
        "❤️ Tüm dersler",
        "🤔 Emin değilim",
      ],
    },
    3: {
      question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
      answers: [
        "😌 Evet, Microsoft Word/PowerPoint",
        "🖥 Evet, temel kodlama",
        "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
        "🤔 Hayır",
      ],
    },
    4: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true
        },
      ],
    },
  },
};

